import React from 'react';
import { Card } from '@nextui-org/react';
import { useLocation, useNavigate } from 'react-router';
import logo from '../../../assets/wilma_care_welcome_logo.svg';
import theme from '../../theme';
import UserCard from './UserCard';
import PeopleIcon from '@mui/icons-material/People';
import HouseRoundedIcon from '@mui/icons-material/HouseRounded';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import Typography from './Typography';
import VetrhoBranding from '../others/VetrhoBranding';

interface Props {
  className?: string;
}

export default function Navabr({
  className
}: Props) {

  const navigate = useNavigate();
  const location = useLocation();

  const renderNavBarItem = (
    title: string,
    to: string,
    icon: any
  ) => (
    <Card
      isPressable
      shadow='none'
      className={`w-full p-2 ${className}`}
      style={{backgroundColor: location.pathname === to ? '#9AECED4D' : 'transparent'}}
      disableRipple
      onPress={() => navigate(to)}>
        <div className='w-full h-auto flex items-center gap-4'>
          {icon}
          <Typography colorVariant='primary'>{title}</Typography>
        </div>
    </Card>
  )

  return (
    <div
      style={{backgroundColor: theme.color.background}} 
      className='flex flex-col bg-gray-100 p-7 w-full sm:w-64 md:w-72 lg:w-80 max-w-xs'>
      <img src={logo} 
        alt='Wilmacare' 
        className="w-full h-auto max-w-full"/>
      <UserCard 
        style={{marginTop: theme.sizing.x6}}/>
      <div className='flex flex-col gap-4 mt-8'>
        {renderNavBarItem('COLLOQUIO', '/interview', <PeopleIcon style={{color: theme.color.primary}} />)}
        {renderNavBarItem('FAMIGLIE', '/families', <HouseRoundedIcon style={{color: theme.color.primary}} />)}
        {renderNavBarItem('BADANTI', '/caregivers', <GroupsRoundedIcon style={{color: theme.color.primary}} />)}
      </div>
      <VetrhoBranding 
        style={{marginTop: 'auto'}}/>
      <Typography colorVariant='textLabel' className='text-center mt-2'>v 0.0.7</Typography>
    </div>
  )
}